import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import './ScrollableCards.scss';
import CheckIcon from '@material-ui/icons/Check';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {
  apiValidation,
  get,
  iosCaller,
  iosRedirect,
  isIosApp,
  isWebView,
  post,
  updateUsageTrack,
} from '../../../Utilities';
import teacherImg from '../../../assets/images/LiveClasses/teacher.png';
import TimerWatch from '../../Live Classes/TimerWatch';
import Swal from 'sweetalert2';
import { Spinner } from 'react-bootstrap';
import { useCreditsModal } from '../ToastModal/ToastModal';

const getYoutubeIdFromLink = (link) => {
  let viId = '';
  if (link.includes('https')) {
    if (link.includes('.be')) {
      viId = link.split('/').pop();
    } else {
      /* eslint-disable */
      viId = link.split('v=')[1];
      const ampersandPosition = viId?.indexOf('&');
      if (ampersandPosition != -1) {
        viId = viId?.substring(0, ampersandPosition);
      }
    }
  } else {
    viId = link;
  }
  console.log(viId, 'youtubeIdToPlay');
  return viId;
};

export const LiveClassesCards = (props) => {
  const { liveClasses, history, firstName, lastName, clientUserId, clientId, dashboardData } =
    props;
  const [domain, setDomain] = useState('tcalive.ingenimedu.com');
  const [zoomMeeting, setZoomMeeting] = useState(null);
  const [zoomPassCode, setZoomPassCode] = useState(null);
  const [zoomPassCodeModal, setZoomPassCodeModal] = useState(false);
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);
  const [zoomMeetObj, setZoomMeetObj] = useState({});
  const [joiningZoomAndroid, setJoiningZoomAndroid] = useState(false);

  const showModalTrigger = useCreditsModal();

  const copyToClipboard = () => {
    setCopiedToClipboard(true);
  };

  const addLiveStreamAttendanceOfStudent = (element, st = null, cb) => {
    const payload = {
      client_user_id: clientUserId,
      stream_id: element.stream_id,
      stream_type: st || element.stream_type,
      client_id: clientId,
    };
    post(payload, '/addLiveStreamAttendanceOfStudent').then((res) => {
      if (res && res.success && res.result?.credits_added) {
        setTimeout(() => {
          showModalTrigger({
            credits: res.result?.credits || 5,
          });
        }, 6000);
      }
      cb();
    });
  };

  const rejoinBigBlueButtonStream = (firstname, lastname, streadId, clientUserid, role) => {};

  const openZoomPasscodeModal = () => setZoomPassCodeModal(true);

  const checkLiveStreamAndJoin = (elem) => {
    const payload = {
      client_user_id: clientUserId,
      client_id: clientId,
    };
    let classAttended = '';
    get(payload, '/getLiveStreamExperienceOfUser').then((res) => {
      if (res && res.success) {
        classAttended = res.result.class_attended;

        get(payload, '/getAllScheduledClassesForStudent').then((res) => {
          if (res && res.success) {
            const result = apiValidation(res);

            const clicked = result.find((ele) => {
              return ele.stream_id === elem.stream_id;
            });
            if (!clicked) {
              Swal.fire({
                html: `<p style='font-size: 18px; margin-bottom: 0px'><b>This class has ended.</b></p>`,
              });
            } else if (clicked.status === 'active') {
              startLiveStream(elem, classAttended);
            } else if (clicked.status === 'pending') {
              Swal.fire({
                html: `<p style='font-size: 18px; margin-bottom: 0px'><b>Class not started yet.</b></p>`,
              });
            } else {
              Swal.fire({
                html: `<p style='font-size: 18px; margin-bottom: 0px'><b>This class has ended.</b></p>`,
              });
            }
          }
        });
      }
    });
  };

  const startLiveStream = (element, classAttended) => {
    let emoji = '';
    if (clientId === 2050) {
      if (classAttended === 0) {
        emoji = '🟢 ';
      } else if (classAttended < 16) {
        emoji = '🟢 ';
      } else if (classAttended < 46) {
        emoji = '🟡 ';
      } else emoji = '🔵 ';
    }

    if (element.stream_type === 'zoom') {
      if (dashboardData.live_class_platform.zoom_inapp) {
        addLiveStreamAttendanceOfStudent(element, 'zoom', function () {
          if (isWebView && typeof window.Android.startOrJoinZoomMeeting !== 'undefined') {
            get({}, '/generateTokenForZoomSdk').then((tokenres) => {
              if (tokenres && tokenres.success) {
                const jwtToken = tokenres.result;
                setJoiningZoomAndroid(true);
                window.Android.disableScreenshot();
                window.Android.startOrJoinZoomMeeting(
                  JSON.stringify({
                    jwt_token: jwtToken,
                    display_name: emoji + firstName + ' ' + lastName,
                    meeting_id: String(element.meeting_id),
                    password: element.password,
                    startOrJoin: 'join',
                    start_url: 'no url',
                  }),
                );
                setTimeout(() => {
                  setJoiningZoomAndroid(false);
                }, 7000);
              }
            });
          } else if (isIosApp) {
            get({}, '/generateTokenForZoomSdk').then((tokenres) => {
              if (tokenres && tokenres.success) {
                const jwtToken = tokenres.result;
                try {
                  iosCaller('disableScreenshot');
                  iosCaller(
                    'startOrJoinZoomMeeting',
                    JSON.stringify({
                      jwt_token: jwtToken,
                      display_name: emoji + firstName + ' ' + lastName,
                      meeting_id: String(element.meeting_id),
                      password: element.password,
                      startOrJoin: 'join',
                      start_url: 'no url',
                    }),
                  );
                } catch (err) {
                  setZoomMeeting(element.meeting_id);
                  setZoomPassCode(element.password);
                  setZoomMeetObj(element);
                  openZoomPasscodeModal();
                }
              }
            });
          } else {
            history.push({
              pathname: '/zoom',
              state: {
                meetingId: element.meeting_id,
                password: element.password,
                username: emoji + firstName + ' ' + lastName,
                email: '',
                startUrl: 'no url',
                startOrJoin: 'join',
              },
            });
          }
        });
      } else {
        setZoomMeeting(element.meeting_id);
        setZoomPassCode(element.password);
        setZoomMeetObj(element);
        openZoomPasscodeModal();
      }
      updateUsageTrack(clientId);

    } else if (element.stream_type === 'meet') {
      addLiveStreamAttendanceOfStudent(element, 'meet', function () {
        if (isWebView) {
          window.location.href = `https://meet.google.com/${element.meeting_id}`;
        } else if (isIosApp) {
          iosRedirect(`https://meet.google.com/${element.meeting_id}`);
        } else {
          window.open(`https://meet.google.com/${element.meeting_id}`, '_blank');
        }
        updateUsageTrack(clientId);
      });
    } else if (element.stream_type === 'zoho') {
      addLiveStreamAttendanceOfStudent(element, 'zoho', function () {
        if (isWebView) {
          window.location.href = element.meeting_link;
        } else if (isIosApp) {
          iosRedirect(element.meeting_link);
        } else {
          window.open(element.meeting_link, '_blank');
        }
        updateUsageTrack(clientId);
      });
    } else if (element.stream_type === 'youtube') {
      const vidId = getYoutubeIdFromLink(element.meeting_id);
      updateUsageTrack(clientId);
      addLiveStreamAttendanceOfStudent(element, 'youtube', function () {
        history.push({
          pathname: '/videoplayer',
          state: {
            link: vidId,
            streamId: element.youtube_stream_id,
            file_name: element.topic || 'LIVE',
          },
        });
      });
    } else console.error('invalid stream type');
  };

  return (
    <>
      {liveClasses?.length > 0 && (
        <section
          className='Scrollable__liveClassesCard mt-3'
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <div className='Scrollable__subHeadTextUnderHeading'>
            <div className='d-flex justify-content-between w-100'>
              <h5 className='Scrollable__coursesInitialHeading mb-1'>Online Classes</h5>
              <button
                className='Scrollable__viewAllButtonForCards mb-0'
                type='button'
                onClick={() => history.push('/liveclasses')}
              >
                View All <ChevronRightIcon />
              </button>
            </div>
            <p className='smallTextUnderHeading'>Attend all your online classes here.</p>
          </div>
          <div
            className='d-flex mx-auto deskDisplayLC'
            style={{ marginTop: '70px', marginBottom: '15px' }}
          >
            {liveClasses.map((elem) => {
              let startTimeText = '';
              let date = '';
              let timeArray = [];
              let time = '';
              let timeLeftInSeconds = '';
              let timeLeft = '';
              let batchesText = '';
              if (liveClasses.length) {
                startTimeText = new Date(+elem.stream_start_time * 1000).toString();
                date = startTimeText.split(' ').slice(1, 3).join(' ');
                timeArray = startTimeText.split(' ')[4].split(':');
                time = '';
                timeLeftInSeconds = +elem.stream_start_time - +elem.current_time;
                timeLeft = new Date(timeLeftInSeconds * 1000).toISOString().substr(11, 8);
                if (timeArray[0] > 12) {
                  time = `${timeArray[0] - 12}:${timeArray[1]} PM`;
                } else {
                  time = `${timeArray[0]}:${timeArray[1]} AM`;
                }
                if (elem.stream_status === 'active') {
                  time = 'LIVE!';
                }
                batchesText = '';
                if (elem.batch_array.length > 1) {
                  batchesText = `with ${elem.batch_array[0]} and ${elem.batch_array.length - 1} ${
                    elem.batch_array.length - 1 > 1 ? 'others' : 'other'
                  }`;
                } else if (elem.batch_array.length === 1) {
                  batchesText = `with ${elem.batch_array[0]}`;
                }
              }
              return (
                /* eslint-disable */
                <div
                  className='course-card col-sm-6 col-sm-4 mr-2'
                  style={{ paddingLeft: 0, paddingRight: 0, maxWidth: '400px', minWidth: '380px' }}
                  key={`elem+${elem.stream_id}`}
                >
                  <Card key={elem?.stream_id} className='scheduleCardDashboard mb-2'>
                    <div className='scheduleCardLeft'>
                      <p className='scheduleCardHeading'>
                        <span className='redTag'>ONLINE</span> Class
                      </p>
                      <p className='scheduleCardText'>
                        by {`${elem?.first_name} ${elem?.last_name}`}
                      </p>
                      <p className='scheduleCardSmallText'>{batchesText}</p>
                      <h5 className='scheduleCardHeading clampOn1Line my-3'>
                        {elem?.topic || 'LIVE NOW'}
                      </h5>
                      {elem?.stream_status === 'pending' && (
                        <>
                          <p className='scheduleCardText'>
                            starts @ {time} on {date}
                          </p>
                          <button
                            onClick={() => {
                              checkLiveStreamAndJoin(elem);
                            }}
                            type='button'
                            disabled={joiningZoomAndroid}
                            className='startNowButton'
                          >
                            {joiningZoomAndroid ? <>Joining...</> : 'Join'}
                          </button>
                        </>
                      )}
                      {elem?.stream_status === 'active' && (
                        <>
                          <p className='scheduleCardText'>Class in progress...</p>

                          <button
                            onClick={() => {
                              checkLiveStreamAndJoin(elem);
                            }}
                            type='button'
                            disabled={joiningZoomAndroid}
                            className='startNowButton'
                          >
                            {joiningZoomAndroid ? <>Joining...</> : 'Attend Now'}
                          </button>
                        </>
                      )}
                    </div>
                    <div className='scheduleCardRight'>
                      {timeLeftInSeconds < 86400 && (
                        <TimerWatch
                          isLive={time === 'LIVE!'}
                          startedProp={timeLeftInSeconds < 0}
                          time={timeLeft}
                        />
                      )}
                      {timeLeftInSeconds >= 86400 && (
                        <img className='teacherImage' src={teacherImg} alt='icon' />
                      )}
                      {/* eslint-disable */}
                      {/* <div
                        onClick={() => this.deleteScheduledClass(elem)}
                        className='deleteContainer'
                      >
                        <DeleteIcon style={{ color: '#00000061' }} />
                      </div> */}
                    </div>
                  </Card>
                </div>
              );
            })}
          </div>

          <Modal show={zoomPassCodeModal} onHide={() => setZoomPassCodeModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Copy PassCode</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col
                  xs={7}
                  className='text-center'
                  style={{ fontFamily: 'Montserrat-Bold', fontSize: '16px', color: 'gray' }}
                >
                  {zoomPassCode}
                </Col>
                <Col cs={5} className='text-center my-auto' onClick={() => copyToClipboard()}>
                  {copiedToClipboard ? (
                    <span
                      style={{
                        fontFamily: 'Montserrat-Medium',
                        fontSize: '14px',
                        color: 'rgba(58, 255, 0, 0.87)',
                      }}
                    >
                      <CheckIcon />
                      Copied To Clipboard!
                    </span>
                  ) : (
                    <Button variant='dark'>
                      <AssignmentIcon /> Copy
                    </Button>
                  )}
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='boldTextSecondary' onClick={() => setZoomPassCodeModal(false)}>
                Cancel
              </Button>
              <Button
                variant='boldText'
                onClick={() => {
                  addLiveStreamAttendanceOfStudent(zoomMeetObj, 'zoom', function () {
                    if (isWebView) {
                      window.location.href = `https://zoom.us/j/${zoomMeeting}?pwd=${zoomPassCode}`;
                    } else if (isIosApp) {
                      iosRedirect(`https://zoom.us/j/${zoomMeeting}?pwd=${zoomPassCode}`);
                    } else {
                      window.open(`https://zoom.us/j/${zoomMeeting}?pwd=${zoomPassCode}`);
                    }
                    updateUsageTrack(clientId);
                  });
                }} //eslint-disable-line
              >
                Attend Meeting Now!
              </Button>
            </Modal.Footer>
          </Modal>
        </section>
      )}
    </>
  );
};

LiveClassesCards.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  liveClasses: PropTypes.instanceOf(Array).isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
};

// col-sm-6 col-md-4 col-lg-2
